document.querySelectorAll('.buy-now-btn').forEach(function(button) {
  button.addEventListener('click', async function(e) {
    e.preventDefault();

    // Disable UpCart drawer temporarily
    const disableDrawer = function() {
      if (window.UpCart) {
        window.UpCart.disable();
      }
    };

    // Re-enable UpCart after redirecting to checkout
    const reenableDrawer = function() {
      if (window.UpCart) {
        window.UpCart.enable();
      }
    };

    // Disable the cart drawer
    disableDrawer();

    // Clear the cart
    try {
      await fetch('/cart/clear', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
      });
    } catch (error) {
      console.error('Error while clearing items from cart:', error);
    }

    try {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          'items': [{
            'id': this.getAttribute('data-variant-id'),
            'quantity': 1
          }]
        })
      });
    } catch (error) {
      console.error('Error while adding items to cart:', error);
    }

    // Redirect to checkout page
    window.location.href = '/checkout';
    reenableDrawer();
  });
});